import styled from '@emotion/styled/macro';
import { Input, InputOwnProps } from '@mui/base';

import { InputType } from './input';

export const InputRoot = styled(Input, {
  shouldForwardProp: (prop) => prop !== 'fullWidth' && prop !== 'error',
})<{ type: InputType; error?: boolean }>((props) => ({
  width: props.fullWidth ? '100%' : 'auto',
  backgroundColor: props.error ? props.theme.colors.background : props.theme.colors.container.primary,
  border: props.error ? `1px solid ${props.theme.colors.error.main}` : `1px solid ${props.theme.colors.container.primary}`,
  display: 'flex',
  color: props.theme.colors.primary,
  padding: '8px 12px',
  cursor: props.readOnly ? 'not-allowed' : 'text',
  '&.Mui-focused, &.base--focused': props.readOnly
    ? {}
    : {
        border: props.error ? `1px solid ${props.theme.colors.error.main}` : `1px solid ${props.theme.colors.accent}`,
        backgroundColor: props.theme.colors.background,
        input: {
          backgroundColor: props.theme.colors.background,
          color: props.theme.colors.primary,
        },
        textarea: {
          backgroundColor: props.theme.colors.background,
          color: props.theme.colors.primary,
        },
      },
  borderRadius: 5,
  'input, textArea': {
    border: 0,
    flex: 1,
    backgroundColor: props.error ? props.theme.colors.background : props.theme.colors.container.primary,
    fontSize: 13,
    padding: 0,
    lineHeight: '16px',
    fontFamily: props.theme.fonts.primary,
    color: props.theme.colors.primary,
    fontWeight: 500,
    outline: 'none',
    cursor: props.readOnly ? 'not-allowed' : 'text',
    '&::placeholder': {
      color: props.theme.colors.inactive,
    },
  },
  // Native HTML5 validation state support
  'input:invalid[pattern]': {
    backgroundColor: props.theme.colors.background,
  },
  '&:has(input:invalid[pattern])': {
    backgroundColor: props.theme.colors.background,
    border: `1px solid ${props.theme.colors.error.main}`,
  },
}));

export const MultilineInputRoot = styled(Input, {
  shouldForwardProp: (prop) => prop !== 'fullWidth' && prop !== 'error',
})<InputOwnProps & { type: InputType; error?: boolean }>((props) => ({
  width: props.fullWidth ? '100%' : 'auto',
  backgroundColor: props.error ? props.theme.colors.background : props.theme.colors.container.primary,
  border: props.error ? `1px solid ${props.theme.colors.error.main}` : `1px solid ${props.theme.colors.container.primary}`,
  display: 'flex',
  color: props.theme.colors.primary,
  padding: '8px 12px',
  '&.Mui-focused, &.base--focused': props.readOnly
    ? {}
    : {
        border: props.error ? `1px solid ${props.theme.colors.error.main}` : `1px solid ${props.theme.colors.accent}`,
        backgroundColor: props.theme.colors.background,
        input: {
          backgroundColor: props.theme.colors.background,
          color: props.theme.colors.primary,
        },
        textarea: {
          backgroundColor: props.theme.colors.background,
          color: props.theme.colors.primary,
        },
      },
  borderRadius: 5,
  'input, textArea': {
    resize: 'none',
    border: 0,
    flex: 1,
    backgroundColor: props.error ? props.theme.colors.background : props.theme.colors.container.primary,
    fontSize: 13,
    padding: 0,
    lineHeight: '16px',
    fontFamily: props.theme.fonts.primary,
    color: props.theme.colors.primary,
    fontWeight: 500,
    outline: 'none',
    '&::placeholder': {
      color: props.theme.colors.inactive,
    },
  },
  // Native HTML5 validation state support
  'input:invalid[pattern], textarea:invalid[pattern]': {
    backgroundColor: props.theme.colors.background,
  },
  '&:has(input:invalid[pattern]), &:has(textarea:invalid[pattern])': {
    backgroundColor: props.theme.colors.background,
    border: `1px solid ${props.theme.colors.error.main}`,
  },
}));
